/**
 * Section component - Landing page section wrapper
 */

import {HTMLAttributes, forwardRef} from 'react';
import {cn} from '../../utils/cn';

interface SectionProps extends HTMLAttributes<HTMLElement> {
  padding?: 'sm' | 'md' | 'lg' | 'xl';
  background?: 'white' | 'gray' | 'gradient';
}

export const Section = forwardRef<HTMLElement, SectionProps>(
  ({className, padding = 'lg', background = 'white', children, ...props}, ref) => {
    return (
      <section
        ref={ref}
        className={cn(
          {
            // Padding variants
            'py-16 sm:py-20': padding === 'sm', // 64px / 80px
            'py-20 sm:py-24': padding === 'md', // 80px / 96px
            'py-section sm:py-section-lg': padding === 'lg', // 128px / 160px
            'py-section-lg sm:py-32': padding === 'xl', // 160px / 128px
            
            // Background variants - more distinct contrast
            'bg-background dark:bg-[#1E1E1E]': background === 'white',
            'bg-backgroundSecondary dark:bg-[#252526]': background === 'gray',
            'bg-gradient-to-b from-backgroundSecondary to-background dark:from-[#252526] dark:to-[#1E1E1E]': background === 'gradient',
          },
          className
        )}
        {...props}
      >
        {children}
      </section>
    );
  }
);

Section.displayName = 'Section';

